export default __webpack_public_path__ + "static/media/Uh-oh.cbc50c0d.svg";